import { useAxios } from "@hooks"
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { App } from "antd";
import { useTranslation } from "react-i18next";
import dayjs from "dayjs";

export const useEditExamGroup = (examPeriodScreen?: boolean) => {
    
    const axios = useAxios();
    const {t} = useTranslation();
    const queryClient = useQueryClient();
    const {message} = App.useApp();

    const editExamGroup = async (examGroup: any) => {
        let exam = {...examGroup};
        
        if (exam.examGroupProperties && exam.examGroupProperties.timeInSeconds) {
            const day = dayjs(exam.examGroupProperties.timeInSeconds);
            const hours = day.hour();
            const minutes = day.minute();
            const seconds = day.second();
            exam.examGroupProperties.timeInSeconds = (hours * 3600) + (minutes * 60) + seconds;                
        } else {
            delete exam.examGroupProperties?.timeInSeconds;
        }

        if (exam.timeInSeconds) {
            const day = dayjs(exam.timeInSeconds);
            const hours = day.hour();
            const minutes = day.minute();
            const seconds = day.second();
            exam.timeInSeconds = (hours * 3600) + (minutes * 60) + seconds;                
        } else {
            delete exam.timeInSeconds;
        }
      
        
        try {
            console.log(exam);
            if (examPeriodScreen) {
                const response = await axios.put(`/api/ExamTerms/group`, exam);
                return response.data;
            } else {
                const response = await axios.put(`/api/examgroup/${examGroup.id}`, exam);
                return response.data;
            }
            
        } catch (error) {
            throw new Error(t("messages.error.editExamGroup"));
        }
    }

    return useMutation({mutationFn: editExamGroup, onSuccess: () => {
        queryClient.invalidateQueries({queryKey: ["examGroups"]});
        queryClient.invalidateQueries({queryKey: ["examQuestionSummary"]});
        message.success(t("messages.success.editExamGroup"));
    }});
}